import type { StatusPillColors } from '../StatusPill/StatusPill';

import { twMerge } from 'tailwind-merge';

import { getDefaultImageProperties, strToChecksum } from '../../lib/helpers';

import Button from '../Button/Button';
import StatusPill from '../StatusPill/StatusPill';

interface SearchResultTileProps {
  /**
   * A text title for the result
   */
  title?: string;
  /**
   * Image url for the results with visual representation
   */
  image?: string;
  /**
   * A string with additional object properties to display
   */
  properties?: string;
  /**
   * Content type label
   */
  ctdLabel?: string;
  /**
   * Content type name to be used for color selection
   */
  ctdName?: string;
  /**
   * Set to true for highlighting the tile
   */
  selected?: boolean;
  /**
   * Click event callback
   */
  onClick?: () => void;
}

const SearchResultTile = ({
  title = '',
  image = '',
  properties = '',
  ctdLabel = '',
  ctdName = '',
  selected = false,
  onClick,
}: SearchResultTileProps) => (
  <Button
    buttonSize="lg"
    buttonColor="borderless"
    additionalClasses={twMerge(
      'rounded-sm w-full border hover:bg-slate-50 h-12 px-2 dark:hover:text-slate-900',
      selected
        ? 'bg-slate-50 border-blue dark:text-slate-900'
        : 'border-transparent',
    )}
    additionalChildrenClasses={'w-full'}
    onClick={onClick}
  >
    <span className="text-left flex w-full items-center gap-4 whitespace-nowrap">
      {image && (
        <img
          src={image}
          alt={title}
          className="w-12 h-12 rounded-sm"
          {...getDefaultImageProperties()}
        />
      )}
      {title && (
        <span className="min-w-[20%] max-w-[30%] w-full truncate">{title}</span>
      )}{' '}
      <StatusPill
        color={
          ['lime', 'blue', 'red', 'orange'][
            strToChecksum(ctdName) % 4
          ] as StatusPillColors
        }
        status={ctdLabel}
      />
      {!!properties && (
        <span
          className="truncate text-slate-400/80 text-sm space-x-2 max-w-[50%]"
          title={properties}
        >
          {properties}
        </span>
      )}
    </span>
  </Button>
);

export default SearchResultTile;
